import { Directive, ElementRef, inject, OnInit } from '@angular/core';
import { LayoutService } from 'src/app/_metronic/layout/core/layout.service';

@Directive({ selector: '[appContentContainerClass]' })
export class ContentContainerClassDirective implements OnInit{

  private layout: LayoutService;
  private el: ElementRef;

  constructor() {
    this.layout = inject(LayoutService);
    this.el = inject(ElementRef);
  }
  
  public ngOnInit(): void {
    this.el.nativeElement.classList.add(this.layout.getStringCSSClasses('contentContainer'));
  }
}
